class DrawerMenu extends HTMLElement {
  constructor() {
    'use strict';
    super();

    this.el = this;
    this.mainLevel = this.el.querySelector('.drawer-menu__contents');
    this.init();
  }

  init() {
    // These toggle submenu panel
    this.firstLevelItemsWithChildren = this.el.querySelectorAll('.drawer-menu__item__button');
    this.firstLevelItemsWithChildren.forEach((button) => {
      button.addEventListener('click', this.toggleMenuItem.bind(this));
    });

    // These handle closing of navigation
    this.closeButtons = this.el.querySelectorAll('[data-close]');
    this.closeButtons.forEach((btn) => {
      btn.addEventListener('click', this.closeAllItems.bind(this));
    });

    this.overlay = this.el.querySelector('[data-drawer-overlay]');
    this.overlay.addEventListener('click', this.closeAllItems.bind(this));

    // These handle going back to previous panel
    this.secondLevelBackButtons = this.el.querySelectorAll('[data-drawer-submenu-close]');
    this.secondLevelBackButtons.forEach((button) => {
      button.addEventListener('click', this.toggleSubPanel.bind(this));
    });

    // Handle opening of specific subitem from anywhere in the theme
    this.subitemOpeners = document.querySelectorAll('[data-drawer-submenu-open]');
    this.subitemOpeners.forEach((button) => {
      button.addEventListener('click', this.toggleMenuItemFromTheme.bind(this));
    });

    // Add analytics events for drawer menu elements
    window._mtm = window._mtm || [];
    this.querySelectorAll('[data-type="leftMenuLink"]').forEach(item => {
      item.addEventListener('click', (event) => {
        const eventName = event.currentTarget.innerText.trim();
        window._mtm.push({
          event: 'leftMenuClicks',
          category: 'ecommerce',
          action: 'left menu click',
          name: eventName,
        });
      });
    });
  }

  closeAllItems(event, skipEl) {
    const accordions = this.mainLevel.querySelectorAll('[data-accordion-item].is-open');
    accordions.forEach((accordion) => {
      const button = accordion.querySelector('button');
      if (skipEl && button === skipEl) {
        return;
      }
      if (button) {
        accordion.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
        if (screen.width <= 820) {
          const parent = accordion.closest('.drawer-menu__contents');
          parent.classList.remove('pull-left');
        }
      }
    });

    if (!skipEl) {
      this.mainLevel.classList.remove('has-open-submenu');
    }
  }

  toggleMenuItem(scope) {
    const button = scope.currentTarget || scope;
    if (!button) return;

    this.closeAllItems(scope, button);

    const accordion = button.closest('[data-accordion-item]');
    if (!accordion) {
      return;
    }
    if (screen.width <= 820) {
      const parent = accordion.closest('.drawer-menu__contents');
      parent.classList.toggle('pull-left');
    }
    
    const isOpen = accordion.classList.contains('is-open');
    accordion.classList.toggle('is-open');
    button.setAttribute('aria-expanded', (!isOpen).toString());
    
    if (accordion.classList.contains('is-open')) {
      this.mainLevel.classList.add('has-open-submenu');
    } else {
      this.mainLevel.classList.remove('has-open-submenu');
    }
  }

  toggleMenuItemFromTheme(scope) {
    let target = false;
    const button = scope.currentTarget || scope;
    const url = button.getAttribute('data-drawer-submenu-open');

    for (const menuButton of this.firstLevelItemsWithChildren) {
      if (menuButton.getAttribute('data-href') === url) {
        target = menuButton;
        break;
      }
    }

    if (!target) return;

    Woolman.ModalsAndDrawers.showModalOrDrawer(this.el.getAttribute('id'));

    const animationFinished = () => {
      this.el.removeEventListener('transitionend', animationFinished);

      target.click();
      
      // Focus the target button in the drawer menu for accessibility
      setTimeout(() => {
        target.focus();
      }, 100);
    };
    this.el.addEventListener('transitionend', animationFinished);
  }

  toggleSubPanel(event) {
    this.closeAllItems();

    const button = event.currentTarget;
    const targetSelector = button.getAttribute('data-drawer-submenu-close');
    if (!targetSelector) {
      return;
    }

    const targetButton = document.getElementById(targetSelector + '-button');
    if (!targetButton) {
      return;
    }

    targetButton.focus();
  }
}

if (customElements.get('drawer-menu') === undefined) {
  customElements.define('drawer-menu', DrawerMenu);
}
